<template>
    <main class="clearfix">
        <div class="main-left">
            <side-nav></side-nav>
        </div>
        <div class="main-right">
            <b-container fluid class="mt-2">
                <router-view>
                    <h1>Dashboard</h1>
                </router-view>
            </b-container>
        </div>
    </main>
</template>

<script>
  import SideNav from './side-nav/SideNav.vue'

  export default {
    name: 'home',
    components: {
      'side-nav': SideNav
    },
    data () {
      return {
        user: {},
        alertType: 'danger',
        alertMessage: 'Empty',
        dismissCountDown: null
      }
    },
    methods: {
      countDownChanged: function (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      }
    },
    created: function () {
      this.logConsole('Main panel created')
    }
  }
</script>

<style lang="scss" type="text/scss">
    @import '~@/assets/scss/variables.scss';

    $nav-width: 250px;

    main {
        height: 100%;
        position: relative;
        z-index: 0;
        &::before {
            content: '';
            display: block;
            width: $nav-width;
            position: fixed;
            left: 0;
            top: $header-height;
            bottom: 0;
            z-index: 0;
            background-color: white;
        }
    }

    @media (max-width: 800px) {
        .main-left {
            float: none !important;
            width: 100% !important;
        }
    }

    .main-left {
        position: relative;
        z-index: 1;
        float: left;
        // display: inline-block;
    }

    @media (max-width: 800px) {
        .main-right {
            float: none !important;
            width: 100% !important;
        }
    }

    .main-right {
        flex-direction: row-reverse;
        display: flex;
        position: relative;
        z-index: 1;
    }

    .modal-dialog {
        margin-top: 85px !important;
    }


    .nav-pills, .show > .nav-pills {
        .nav-link.active {
            color: $font-color-light !important;
            background-color: $primary-color !important;
        }
    }

    .alert-right {
        position: relative;
        z-index: 1;
        margin-left: #{$nav-width};
    }
</style>



// WEBPACK FOOTER //
// Home.vue?1eca9a34